

































































































import { tagApi } from '../tag.api';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component } from 'vue-property-decorator';
import { PaginationResult } from '@shared/common/types';
import { Tag } from '../tag';

@Component
export default class TagsTable extends BaseTable {
  public async fetchData(): Promise<PaginationResult<Tag>> {
    return await tagApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }
}
